import { api } from './api';
import { getCookie } from 'utils/cookies';

export interface ILoginData {
	email: string;
	password: string;
}

export interface ISetPasswordEmail {
	email: string;
	uid: string;
	token: string;
	new_password1: string;
	new_password2: string;
}

export const user_apis = {
	login: (login_data: ILoginData) => api.post(`/member/auth/login`, login_data),
	logout: () => api.post(`/member/auth/logout`),
	getWorkspaceCode: async () => {
		const data = await api.get(`/member/workspace/on-premise`);

		return data.data.result;
	},
	sendPasswordEmail: (email: string) =>
		api.post(`/member/auth/password/reset`, { email: email, on_premise: '' }),
	setPasswordEmail: (uid: string, token: string, data: ISetPasswordEmail) =>
		api.post(`/member/auth/password/reset-confirm/${uid}/${token}`, data),
	getUserData: async () => {
		const data = await api.get(`/member/info`, {
			headers: { Authorization: `Bearer ${getCookie('access_token')}` },
		});

		return data.data.result;
	},
};
